package uz.ferro.erp.feature.text.model

enum class TextStyle {
    NORMAL,
    BOLD,
    ITALIC,
    BOLD_ITALIC
}